import TagManager from "react-gtm-module";

function UpdateSubscriptionSettingsButton({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "update_subscription_settings_button",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default UpdateSubscriptionSettingsButton;
